import { Grid, Stack, Typography } from '@mui/material';

import React from 'react';

import { scrollProps, toSentenceCase } from 'common/utils/utilFunctions';

import { ITestSelectControlData } from 'features/TestMonitoring/api/type-def';

import styles from './TestAreaDetails.module.scss';

interface ItestAreaProps {
	controlData: ITestSelectControlData;
}

const TestAreaDetails = (props: ItestAreaProps) => {
	const { controlData } = props;
	return (
		<div>
			<Grid
				spacing={4}
				className={styles['test-area-grid']}
				sx={scrollProps('y-axis')}
			>
				<Grid item>
					<Grid>
						{controlData.risks.length > 0 && (
							<Grid item>
								<Typography className={styles['risk-background']}>
									<Stack direction="row" className={styles['count-name-stack']}>
										Risks{' '}
										<Typography className={styles['count-data']}>
											{`(${controlData.risks.length})`}
										</Typography>
									</Stack>
								</Typography>
							</Grid>
						)}
						<Grid item className={styles['name-stack']}>
							<Stack
								direction="row"
								spacing={2}
								className={styles['name-container']}
							>
								{controlData.risks.map((risk) => (
									<Typography
										key={risk.riskId}
										className={styles['risk-names']}
									>
										{risk.riskName}
									</Typography>
								))}
							</Stack>
						</Grid>
					</Grid>
				</Grid>
				{controlData.citations.length > 0 && (
					<Grid item>
						<Grid>
							<Grid item>
								<Stack>
									<Typography className={styles['citations-background']}>
										<Stack
											direction="row"
											className={styles['count-name-stack']}
										>
											Citations{' '}
											<Typography className={styles['count-data']}>
												{`(${controlData.citations.length})`}
											</Typography>
										</Stack>
									</Typography>
								</Stack>
							</Grid>
							<Grid item className={styles['name-stack']}>
								<Stack
									direction="row"
									spacing={2}
									className={styles['name-container']}
								>
									{controlData.citations.map((citation) => (
										<Typography
											key={citation.citationId}
											className={styles['citation-names']}
										>
											{citation.citationName}
										</Typography>
									))}
								</Stack>
							</Grid>
						</Grid>
					</Grid>
				)}
				<Grid item>
					{controlData.products.length > 0 && (
						<Grid>
							<Grid item>
								<Stack>
									<Typography className={styles['product-background']}>
										<Stack
											direction="row"
											className={styles['count-name-stack']}
										>
											Products{' '}
											<Typography className={styles['count-data']}>
												{`(${controlData.products.length})`}
											</Typography>
										</Stack>
									</Typography>
								</Stack>
							</Grid>
							<Grid item className={styles['name-stack']}>
								<Stack
									direction="row"
									spacing={2}
									className={styles['name-container']}
								>
									{controlData.products.map((product) => (
										<Typography
											key={product.productId}
											className={styles['product-names']}
										>
											{product.productName}
										</Typography>
									))}
								</Stack>
							</Grid>
						</Grid>
					)}
				</Grid>
				<Grid item>
					{controlData.processes.length > 0 && (
						<Grid>
							<Grid item>
								<Stack>
									<Typography className={styles['process-background']}>
										<Stack
											direction="row"
											className={styles['count-name-stack']}
										>
											Processes{' '}
											<Typography className={styles['count-data']}>
												{`(${controlData.processes.length})`}
											</Typography>
										</Stack>
									</Typography>
								</Stack>
							</Grid>
							<Grid item className={styles['name-stack']}>
								<Stack
									direction="row"
									spacing={2}
									className={styles['name-container']}
								>
									{controlData.processes.map((process) => (
										<Typography
											key={process.processId}
											className={styles['process-names']}
										>
											{process.processName}
										</Typography>
									))}
								</Stack>
							</Grid>
						</Grid>
					)}
				</Grid>
				<Grid item>
					{controlData.policies.length > 0 && (
						<Grid>
							<Grid item>
								<Stack>
									<Typography className={styles['policy-background']}>
										<Stack
											direction="row"
											className={styles['count-name-stack']}
										>
											Policies{' '}
											<Typography className={styles['count-data']}>
												{`(${controlData.policies.length})`}
											</Typography>
										</Stack>
									</Typography>
								</Stack>
							</Grid>
							<Grid item className={styles['name-stack']}>
								<Stack
									direction="row"
									spacing={2}
									className={styles['name-container']}
								>
									{controlData.policies.map((policy) => (
										<Typography
											key={policy.policyId}
											className={styles['policy-names']}
										>
											{policy.policyName}
										</Typography>
									))}
								</Stack>
							</Grid>
						</Grid>
					)}
				</Grid>
				<Grid item>
					{controlData.termsAndConditions.length > 0 && (
						<Grid>
							<Grid item>
								<Stack>
									<Typography className={styles['condition-background']}>
										<Stack
											direction="row"
											className={styles['count-name-stack']}
										>
											{toSentenceCase('Terms & Conditions')}{' '}
											<Typography className={styles['count-data']}>
												{`(${controlData.termsAndConditions.length})`}
											</Typography>
										</Stack>
									</Typography>
								</Stack>
							</Grid>
							<Grid item className={styles['name-stack']}>
								<Stack
									direction="row"
									spacing={2}
									className={styles['name-container']}
								>
									{controlData.termsAndConditions.map((terms) => (
										<Typography
											key={terms.termsAndConditionId}
											className={styles['condition-names']}
										>
											{terms.termsAndConditionName}
										</Typography>
									))}
								</Stack>
							</Grid>
						</Grid>
					)}
				</Grid>
			</Grid>
		</div>
	);
};

export default TestAreaDetails;
